import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeOrganizationsHome, routeOrganizationsRoot } from './organizationsRoutes'
import { routePersonsRoot } from './personsRoutes'

const routeRelationshipsHome: RouteRecordRaw = {
  name: 'relationships-home',
  path: '',
  redirect: routeOrganizationsHome,
}
const routeRelationshipsRoot: RouteRecordRaw = {
  children: [routeRelationshipsHome, routePersonsRoot, routeOrganizationsRoot],
  path: 'relationships',
}

const redirectRelationships: RedirectRouteRelative = {
  name: routeRelationshipsHome.name,
}

export { redirectRelationships, routeRelationshipsHome, routeRelationshipsRoot }
